// extracted by mini-css-extract-plugin
module.exports = {"borrowerInfo":"AgeNextBirthday_borrowerInfo__5Cx5N","dob":"AgeNextBirthday_dob__nEdn0","checkboxWrapper":"AgeNextBirthday_checkboxWrapper__A1Wfw"};